export function getS3galeria(state) {
  return state.S3galeria;
}
export function getS3carpetas(state) {
  return state.S3carpetas;  
}



